import {css} from '@emotion/css';
import {useMemo} from 'react';

const useStyle = (minHeight: number, graphWidth: number) => {
    return useMemo(
        () => ({
            chartWrapper: css({
                height: '100%',
                minHeight: minHeight,
                position: 'relative',
                width: '100%',
            }),
            chartWrapperInner: css({
                position: 'absolute',
                width: graphWidth || '100%',
            }),
        }),
        [minHeight, graphWidth]
    );
};

export default useStyle;
